import * as types from "./actionTypes";
import simulatieDossierApi from "../api/simulatieDossierApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import * as constants from "../constants/DomainConstants";

export function simulatieDossierLoaded(simulatieDossier, errors, validationMessageType, isSaved = true) {
	return {
		type: types.SIMULATIEDOSSIER_LOADED,
		body: {
			item: simulatieDossier,
			errors: errors,
			validationMessageType,
			isSaved: isSaved
		}
	};
}

export function infrastructurenInDeBuurtLoaded(infrastructurenModel) {
	return {
		type: types.SIMULATIEINFRASTRUCTUREN_LOADED,
		body: {
			item: infrastructurenModel
		}
	};
}

export function storeSimulatieDossier(simulatieDossier) {
	return function (dispatch) {
		dispatch(simulatieDossierLoaded(simulatieDossier));
	};
}

export function resetInfrastructuurErrors(infrastructuur) {
	return (dispatch) => {
		dispatch(simulatieInfrastructuurValidated(null));
		dispatch(simulatieInfrastructuurSaved(infrastructuur, true));
	};
}

export function removeInfrastructuur(infrastructuurId) {
	return (dispatch) => {
		dispatch(simulatieInfrastructuurValidated(null));
		dispatch(simulatieInfrastructuurRemoved(infrastructuurId));
	};
}

export function generateRapportSimulatieDossier(dossierId) {
	return function (dispatch) {
		dispatch(ajax.started());

		return simulatieDossierApi.generateRapport(dossierId)
			.then(response => {
				dispatch(ajax.ended());
				// dispatch(simulatieDossierLoaded(response.data.item, response.data.validationResults));
				return response;
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
				return false;
			});
	};
}

export function getInfrastructurenInDeBuurt(lengtegraad, breedtegraad) {
	return function (dispatch) {
		dispatch(ajax.started());

		return simulatieDossierApi.getInfrastructurenInDeBuurt(lengtegraad, breedtegraad)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(infrastructurenInDeBuurtLoaded(response.data));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

// ----------------------------------------------------------------------------
export function simulatieInfrastructuurSaved(infrastructuur, isReset) {
	return {
		type: types.SIMULATIEINFRASTRUCTUUR_SAVED,
		body: {
			item: infrastructuur,
			isReset: isReset
		}
	};
}

// ----------------------------------------------------------------------------
export function simulatieInfrastructuurRemoved(infrastructuurId) {
	return {
		type: types.SIMULATIEINFRASTRUCTUUR_REMOVED,
		body: {
			item: infrastructuurId
		}
	};
}

export function simulatieInfrastructuurValidated(errors) {
	return {
		type: types.SIMULATIEINFRASTRUCTUUR_VALIDATED,
		body: {
			errors: errors
		}
	};
}

export function saveSimulatieInfrastructuur(infrastructuur) {
	return (dispatch) => {
		dispatch(ajax.started());
		return simulatieDossierApi.validateInfrastructuur(infrastructuur)
			.then(response => {
				dispatch(ajax.ended());
				if (Object.keys(response.data.validationResults).length !== 0) {
					dispatch(simulatieInfrastructuurValidated(response.data.validationResults));
					return constants.HAS_VALIDATION_ERRORS;
				}
				else {
					dispatch(simulatieInfrastructuurSaved(infrastructuur, false));
					return constants.SUCCESS_NO_TOASTR;
				}
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}